import React from 'react'
import type { PayloadReactComponent, SanitizedConfig } from 'payload'

export const Avatar: PayloadReactComponent<
    SanitizedConfig['admin']['avatar']
> = () => {
    return <div></div>
}
